import { CloseButton } from "@/components/CloseButton/CloseButton";
import { InfoTip } from "@/components/InfoTip/InfoTip";
import { UIButton } from "@/components/UIButton/UIButton";
import {
  currentOrderAtom,
  paymentLinkAsync,
} from "@/core/reatom/state/orders/orders";
import { useAtom } from "@reatom/npm-react";
import { openLink } from "@telegram-apps/sdk-react";
import { Icon56MoneyTransferOutline } from "@vkontakte/icons";
import { Spacing } from "@vkontakte/vkui";
import s from "./style.module.scss";

interface PaymentModalProps extends BaseModalProps {}

export const PaymentModal = ({ closeModal }: PaymentModalProps) => {
  const [currentOrder] = useAtom(currentOrderAtom);
  const [link] = useAtom(paymentLinkAsync.dataAtom);

  const payment = () => {
    openLink(link);
  };

  return (
    <div className={s.wrapper}>
      <CloseButton onClose={closeModal} />
      <Icon56MoneyTransferOutline className={s.icons} />
      <p className={s.title}>Оплата услуги</p>
      <p className={s.description}>Сумма спишется с банковской карты.</p>
      <Spacing size={8} />
      <InfoTip>
        Если в течение суток исполнитель не приступит к работе - деньги
        мгновенно вернутся на карту.
      </InfoTip>
      <UIButton
        fontType={"primary-2"}
        className={s.button}
        color="light-green"
        onClick={() => payment()}
      >
        Оплатить {currentOrder?.reserve_price?.toLocaleString("ru-RU")} ₽
      </UIButton>
      <p className={s.terms}>
        Я принимаю условия{" "}
        <span
          onClick={() => {
            openLink(
              "https://st.fl.ru/about/documents/uslugi-freelancera/contract_fiz.pdf"
            );
          }}
        >
          Оферты на заключение Договора об использовании онлайн сервиса
          «Защищенная Сделка в рамках сервиса Типовые услуги»,
        </span>{" "}
        <span
          onClick={() => {
            openLink(
              "https://st.fl.ru/about/documents/uslugi-freelancera/agreement_fiz.pdf"
            );
          }}
        >
          Оферты на заключение соглашения о выполнении работы и/или оказании
          услуги,
        </span>{" "}
        <span
          onClick={() => {
            openLink("https://kassa.com/offers/fl");
          }}
        >
          Публичной оферты об использовании Платежного сервиса «Безопасный
          перевод»
        </span>{" "}
      </p>
    </div>
  );
};
